/* eslint-disable max-len */
import { WorkflowSnippetFn } from '../types';

export const text: WorkflowSnippetFn = (props) => `
from clarifai.client.workflow import Workflow

# Your PAT (Personal Access Token) can be found in the Account's Security section

# Initialize the workflow_url
workflow_url = "https://clarifai.com/${props.userId}/${props.appId}/workflows/${props.workflowId}"
text_classfication_workflow = Workflow(
    url= workflow_url , pat="${props.pat}"
)
result = text_classfication_workflow.predict_by_bytes(b"I hate you", input_type="text")
print(result.results[0].outputs[0].data)
`;

export const image: WorkflowSnippetFn = (props) => `
from clarifai.client.workflow import Workflow

image_url = "https://cdn-bfgco.nitrocdn.com/PLGJnButkKeCQigeKyiwHwnQLZJDOQZI/assets/images/optimized/rev-96fa12a/delamere.com/wp-content/uploads/2022/02/Picture1-1024x683.jpg"
workflow_url =  "https://clarifai.com/${props.userId}/${props.appId}/workflows/${props.workflowId}"
# Creating the workflow
image_classifcation_workflow = Workflow(
    url=workflow_url, pat="${props.pat}"
)

# Getting the predictions
result = image_classifcation_workflow.predict_by_url(image_url ,
    input_type="image",
)
print(result.results[0].outputs[0].data)
`;

export const audio: WorkflowSnippetFn = (props) => `
from clarifai.client.user import User


# Create a new app (replace USER_ID and APP_ID with your own)
app = User(user_id="${props.userId}", pat="${props.pat}").create_app(
    app_id="${props.appId}", base_workflow="Empty"
)
# Create ASR-Sentiment workflow
asr_sentiment_workflow = app.create_workflow(
    config_filepath="configs/asr_sentiment.yml"
)

audio_url = "https://s3.amazonaws.com/samples.clarifai.com/GreatPresentation2.wav"

# Infer workflow on an audio input
prediction = asr_sentiment_workflow.predict_by_url(
    audio_url,
    input_type="audio",
)

# Get workflow results
print(prediction.results[0].outputs[-1].data)
`;
